




















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { ExternalUser } from '@/models/externalUser';
import { pmAppliedLessonWebservice } from '@/webservices/pmappliedlesson';
import type { Project } from '@/models/project';
import MobileDetect from 'mobile-detect';
import type { ProjectUser } from '@/models/projectUser';
import PmToDosFilters from '@/components/toDoWizard/pm/PmToDosFilters.vue';
import type { User } from '@/models/user';
import ProjectChooser from '@/components/utils/ProjectChooser.vue';
import type { PMPhase } from '@/models/pmphase';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'PmToDosList',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        PmToDosFilters,
        ProjectChooser,
    },
})
export default class PmToDosList extends Vue {
    private isModalActive: boolean = false;
    private isFirstSearch: boolean = true;
    private errors: string[] = [];
    private referrer: string = '';

    private selectedResponsibleUsers: ProjectUser[] = [];
    private selectedPmPhases: PMPhase[] = [];
    private appliedLessons: PMAppliedLesson[] = [];
    private isLoadingTasks: boolean = false;

    @Getter('project/selectedProject') private selectedProject: Project;

    @Watch('selectedProject')
    private onSelectedProjectChange() {
        this.appliedLessons = [];
    }

    private mounted() {
        if (this.$route.query.hasOwnProperty('referrer')) {
            this.referrer = this.$route.query.referrer.toString();
            this.isModalActive = true;
        }
    }

    private back() {
        this.$router.push('/projects');
    }

    private get isDesktop() {
        const isNotDesktop = window.matchMedia('only screen and (max-width: 1300px)').matches;
        const md = new MobileDetect(window.navigator.userAgent);
        return !(md.mobile() || md.phone() || md.tablet() || isNotDesktop);
    }

    private load() {
        if (!this.verification()) {
            return;
        }
        this.referrer = '';
        this.isLoadingTasks = true;

        pmAppliedLessonWebservice
            .getProjectOpenTasks(this.selectedPmPhases, this.selectedResponsibleUsers, this.selectedProject)
            .then((res) => {
                this.appliedLessons = res.data;

                this.appliedLessons.forEach((applied_lesson) => {
                    if (applied_lesson.external_responsible_user !== null) {
                        applied_lesson.responsible_user = this.mapUserToProjectUser(
                            applied_lesson.external_responsible_user,
                            true
                        );
                        applied_lesson.external_responsible_user = null;
                    } else if (applied_lesson.internal_responsible_user !== null) {
                        applied_lesson.responsible_user = this.mapUserToProjectUser(
                            applied_lesson.internal_responsible_user,
                            false
                        );
                        applied_lesson.internal_responsible_user = null;
                    }
                });
                this.isFirstSearch = false;
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.isLoadingTasks = false;
            });
    }

    private sendEmail() {
        if (!this.verification()) {
            return;
        }
        this.referrer = '';

        pmAppliedLessonWebservice
            .emailTheOpenTasks(this.selectedPmPhases, this.selectedResponsibleUsers, this.selectedProject)
            .then((res) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$i18n.t('toastMessages.update.emailedOpenTasks').toString(),
                    type: 'is-success',
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private mapUserToProjectUser(user: User | ExternalUser, isExternal: boolean) {
        const responsible_user: ProjectUser = {
            unique_identifier: Math.floor(Math.random() * 100000 + 1),
            user_id: user.id,
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.email,
            isExternalUser: isExternal,
        };
        return responsible_user;
    }

    private verification() {
        this.errors = [];
        if (this.selectedPmPhases.length === 0) {
            this.errors.push('phase');
        } else {
            this.errors.filter((err) => err !== 'phase');
        }

        if (this.selectedResponsibleUsers.length === 0) {
            this.errors.push('responsible_user');
        } else {
            this.errors.filter((err) => err !== 'responsible_user');
        }

        return this.errors.length === 0;
    }
}
